import axios_instance from '../utilities/axios_instance';
import { catalog, statistics, comparison, validId } from '../components/crop-intelligence/publicationContract';
import { exclusionParams } from '../components/crop-intelligence/cropExclusions';

const prefix = 'crop-intelligence/v2';
export const ccErrorCode = (error) => error?.response?.data?.data?.code || error?.response?.data?.code || error?.code || 'ci_request_failed';
export async function ccRequest(path, { method = 'get', params, data, signal, responseType, timeout = 30000 } = {}) {
  try {
    const response = await axios_instance.request({ url: `${prefix}/${path}`, method, params, data, signal, responseType, timeout });
    return responseType === 'blob' ? response.data : response.data.data;
  } catch (error) {
    if (responseType === 'blob' && error.response?.data instanceof Blob) {
      try { error.response.data = JSON.parse(await error.response.data.text()); } catch (_) { /* Non-JSON upstream error. */ }
    }
    if (path !== 'capabilities' && ['ci_access_changed', 'ci_access_revoked', 'ci_identity_not_registered', 'ci_organization_required'].includes(ccErrorCode(error))) {
      window.dispatchEvent(new Event('cc-access-invalidated'));
    }
    throw error;
  }
}
export function scopePath(scope, operation) {
  if (scope.kind === 'me') return `me/${operation}`;
  if (scope.kind === 'commercial_region') return `commercial-regions/${encodeURIComponent(scope.subject_id)}/${operation}`;
  return operation;
}
export const scopeParams = (scope) => ({ ...(scope.kind === 'admin' ? { admin_region_id: scope.subject_id } : {}),
  ...(scope.membership_revision != null ? { membership_revision: scope.membership_revision } : {}) });
const CC = {
  async capabilities(signal) {
    const data = await ccRequest('capabilities', { signal });
    if (!Array.isArray(data?.capabilities) || !validId(data.organization_id) || !validId(data.access_revision)) throw new Error('Invalid CC capabilities');
    return data;
  },
  async catalog(country, signal) { return catalog(await ccRequest('publications', { params: { country_code: country }, signal }), country); },
  async regions(snapshot, parent, cursor, signal) {
    const data = await ccRequest(parent ? `admin-regions/${encodeURIComponent(parent)}/children` : 'admin-regions', {
      params: { country_code: snapshot.country_code, boundary_revision_id: snapshot.boundary_revision_id, cursor, limit: 200 }, signal,
    });
    if (data?.boundary_revision_id !== snapshot.boundary_revision_id || !Array.isArray(data.regions) ||
      data.regions.some((r) => !validId(r.id) || r.parent_id !== (parent || null) || !['COUNTRY', 'PROVINCE', 'DISTRICT', 'VILLAGE'].includes(r.level))) throw new Error('Invalid CC regions');
    return data;
  },
  async stats(snapshot, scope, access, signal, excludedClassKeys = []) {
    return statistics(await ccRequest(scopePath(scope, 'statistics'), { params: { snapshot_id: snapshot.snapshot_id, ...scopeParams(scope), ...exclusionParams(excludedClassKeys) }, signal }), snapshot, scope, access, excludedClassKeys);
  },
  async compare(snapshots, scope, access, options, signal, excludedClassKeys = []) {
    return comparison(await ccRequest(scopePath(scope, 'comparison'), {
      params: { snapshot_ids: snapshots.map((s) => s.snapshot_id).join(','), ...scopeParams(scope), ...options, ...exclusionParams(excludedClassKeys) }, signal,
    }), snapshots, scope, access, excludedClassKeys);
  },
};
export default CC;
